// Presentation helpers shared by the alerts admin tables and forms.

export const ALERT_STATUSES = ["pending", "sending", "sent", "skipped", "failed", "silenced", "disabled"];

export const statusLabelType = (status) =>
    ({
        sent: "success",
        pending: "info",
        sending: "info",
        failed: "error",
        silenced: "warning",
        disabled: "warning",
    }[status] || "info");

export const formatWindow = (seconds) => {
    if (!seconds) return "immediately";
    if (seconds % 3600 === 0) return `${seconds / 3600} h`;
    if (seconds % 60 === 0) return `${seconds / 60} min`;
    return `${seconds} s`;
};

// {"publisher_id": 12, "cron_id": ["a", "b"]} -> ["publisher_id = 12", "cron_id ∈ a, b"]
export const formatMatchers = (matchers) =>
    Object.entries(matchers || {}).map(([key, value]) =>
        Array.isArray(value) ? `${key} ∈ ${value.join(", ")}` : `${key} = ${value}`
    );

export const formatCounts = (counts) =>
    ALERT_STATUSES.filter((status) => counts?.[status])
        .map((status) => `${counts[status]} ${status}`)
        .join(" · ");

export const formatSetting = (field, value) => {
    const effective = value ?? field.default;
    if (field.type === "bool") return effective ? "yes" : "no";
    return String(effective);
};
